import Constants from '../utils/Constants';
import { EXISTS_EMAIL_TEMPLATE } from '../graphql/emailTemplates';
import {createOnErrorHandler} from "../components/errors/Errors";

export const EMAIL_TEMPLATE_NAME_LENGTH = 128;
export const EMAIL_TEMPLATE_RECIPIENTS_LENGTH = 1000;
export const EMAIL_TEMPLATE_SUBJECT_LENGTH = 255;
export const EMAIL_TEMPLATE_BODY_LENGTH = 8000;

export const emailTemplateNameValidator = (t) => (input) => {
    let err = null;
    const maxLetters = EMAIL_TEMPLATE_NAME_LENGTH;
    if (input.trim().length === 0) {
        err = t('email-templates.validation.email-template-name-empty');
    } else if (input.length > maxLetters) {
        err = t('email-templates.validation.email-template-name-too-long', { maxLetters });
    }
    return err;
};

export const emailTemplateNameExistsValidator = (t, dispatch, apolloClient, initialName) => (input) => {
    if (input === initialName) {
        return Promise.resolve();
    }

    return apolloClient.query({
        query: EXISTS_EMAIL_TEMPLATE,
        variables: { name: input },
        fetchPolicy: 'network-only'
    }).then(
        (response) => {
            if (response.data?.existsByName) {
                return Promise.reject(t('email-templates.validation.email-template-name-already-used')); // NOSONAR javascript:S7746
            }
        },
        (error) => {
            const onErrorHandler = createOnErrorHandler(dispatch, apolloClient, null);
            onErrorHandler(error);
            return Promise.reject(t('errors.network')); // NOSONAR javascript:S6671
        }
    );
};

export const emailTemplateRecipientsValidator = (t, emptyAllowed = false) => (input) => {
    let err = null;
    const maxLetters = EMAIL_TEMPLATE_RECIPIENTS_LENGTH;
    if (input.trim().length === 0) {
        if (emptyAllowed) {
            return null;
        }
        err = t('email-templates.validation.email-template-recipients-empty');
    } else if (input.length > maxLetters) {
        err = t('email-templates.validation.email-template-recipients-too-long', { maxLetters });
    } else if (!Constants.COMMA_SEPARATED_EMAILS_REGEX.test(input)) { // NOSONAR javascript:S7735
        err = t('email-templates.validation.email-template-recipients-invalid');
    } else {
        const recipients = input.split(',').map((recipient) => recipient.trim().toLowerCase());
        const hasDuplicate = recipients.some((recipient, index) => recipients.indexOf(recipient) !== index);
        if (hasDuplicate) {
            err = t('email-templates.validation.email-template-recipients-duplicate');
        }
    }
    return err;
};

export const emailTemplateSubjectValidator = (t) => (input) => {
    let err = null;
    const maxLetters = EMAIL_TEMPLATE_SUBJECT_LENGTH;
    if (input.trim().length === 0) {
        err = t('email-templates.validation.email-template-subject-empty');
    } else if (input.length > maxLetters) {
        err = t('email-templates.validation.email-template-subject-too-long', { maxLetters });
    }
    return err;
};

export const emailTemplateBodyValidator = (t) => (input) => {
    let err = null;
    const maxLetters = EMAIL_TEMPLATE_BODY_LENGTH;
    if (input.trim().length === 0) {
        err = t('email-templates.validation.email-template-body-empty');
    } else if (input.length > maxLetters) {
        err = t('email-templates.validation.email-template-body-too-long', { maxLetters });
    }
    return err;
};
